import { PRODUCTS } from "./products";

// ================================
// GROUP PRODUCTS BY CATEGORY
// ================================
const categoryMap = {};

PRODUCTS.forEach((product) => {
  if (!categoryMap[product.navText]) {
    categoryMap[product.navText] = {
      title: product.navText,
      categorySlug: product.navText,
      links: [],
    };
  }

  categoryMap[product.navText].links.push({
    label: product.title,
    to: `/products/${product.categorySlug}`,
  });
});

// Convert map to array (for mega menu columns)
const productColumns = Object.values(categoryMap);

// ================================
// FINAL NAV LINKS
// ================================
const navLinks = [
  { label: "Home", to: "/", type: "link" },
  { label: "About Us", to: "/about-us", type: "link" },

  {
    label: "Products",
    type: "dropdown",
    dropdownIndex: 1,
    columns: productColumns,
  },

  { label: "Blog", to: "/blogs", type: "link" },

  {
    label: "Company Brief",
    type: "dropdown",
    dropdownIndex: 2,
    items: [
      { label: "Award & Membership", to: "/awards-and-memberships" },
      { label: "Quality & Compliance", to: "/quality-and-compliance" },
    ],
  },

  { label: "Gallery", to: "/gallery", type: "link" },
  // { label: "Contact", to: "#contact", type: "link" },
];

export default navLinks;
